// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Switcher-module--cds--assistive-text--9ebb5";
export var cdsVisuallyHidden = "Switcher-module--cds--visually-hidden--c9d46";
export var divider = "Switcher-module--divider--1f517";
export var hideFeedback = "Switcher-module--hide-feedback--a3aa6";
export var link = "Switcher-module--link--21c8c";
export var linkDisabled = "Switcher-module--link--disabled--7e200";
export var nav = "Switcher-module--nav--fd532";
export var open = "Switcher-module--open--2cf09";
export var showFeedback = "Switcher-module--show-feedback--51885";
export var skeleton = "Switcher-module--skeleton--1169c";